// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `ToolbarExpander` is a part of the [Toolbar](#!/Toolbar) component. It is used to split all toolbar controls into two groups:
 * all controls before ToolbarExpander are  aligned left, and all controls after ToolbarExpander are aligned right.
 *
 * `ToolbarExpander` can also be used to create equal space between several control groups in a toolbar.
 */
const ToolbarExpander = ({ baseClassName, className, children, ...props }) => (
    <div className={classNames(baseClassName, className)} {...props}>
        {children}
    </div>
);

ToolbarExpander.propTypes = {
    /**
     * Content of the `ToolbarExpander`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

ToolbarExpander.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}toolbar__expander`,
};

export default ToolbarExpander;



// WEBPACK FOOTER //
// ./components/Toolbar/ToolbarExpander.js